import React, { useState, useRef, useEffect } from 'react';
import { Brain, FileUp, UserPlus2, Building, Construction, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../styles/components/_aifloatingbutton.scss';

const AIFloatingButton: React.FC = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isPulsing, setIsPulsing] = useState(true);
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsExpanded(!isExpanded);
        setIsPulsing(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setIsExpanded(false);
            setIsPulsing(true);
        }
    };

    const handleNavigation = (path: string) => {
        navigate(path);
        setIsExpanded(false);
        setIsPulsing(true);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="ai-floating-button-container" ref={menuRef}>
            <div className={`pulse-ring ${isPulsing ? 'active' : ''}`} />
            <button className="ai-floating-button" onClick={toggleMenu}>
                {isExpanded ? <X size={24} /> : <Brain size={24} />}
            </button>

            <div className={`ai-floating-menu ${isExpanded ? 'expanded' : ''}`}>
                <div className="menu-header">
                    <h2>Assistente inteligente Homecorp</h2>
                    <p>Você precisa de ajuda com o que hoje?</p>
                </div>

                <div className="menu-options">
                    <button
                        className="menu-item"
                        onClick={() => handleNavigation('/propostas/novo')}
                    >
                        <FileUp size={20} />
                        <div className="menu-item-content">
                            <span>Criar nova proposta</span>
                            <small>Inicie um novo processo de venda</small>
                        </div>
                    </button>

                    <button
                        className="menu-item"
                        onClick={() => handleNavigation('/usuarios/novo')}
                    >
                        <UserPlus2 size={20} />
                        <div className="menu-item-content">
                            <span>Criar novo usuário</span>
                            <small>Adicione um novo colaborador</small>
                        </div>
                    </button>

                    <button
                        className="menu-item"
                        onClick={() => handleNavigation('/incorporadoras/novo')}
                    >
                        <Construction size={20} />
                        <div className="menu-item-content">
                            <span>Criar nova incorporadora</span>
                            <small>Registre uma nova empresa</small>
                        </div>
                    </button>

                    <button
                        className="menu-item"
                        onClick={() => handleNavigation('/empreendimentos/novo')}
                    >
                        <Building size={20} />
                        <div className="menu-item-content">
                            <span>Novo empreendimento</span>
                            <small>Cadastre um novo projeto</small>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AIFloatingButton; 